module.exports = __webpack_public_path__ + "static/img/tocImage4.af2c228a.jpg";